import { render, staticRenderFns } from "./BaseApp.vue?vue&type=template&id=d9cbe14c&"
import script from "./BaseApp.vue?vue&type=script&lang=js&"
export * from "./BaseApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports